
<router-outlet></router-outlet>
<!-- <ng-http-loader></ng-http-loader> -->
<ng-http-loader [entryComponent]="LoaderComponent"></ng-http-loader>